<template>
  <div :class="componentClassName">
    <a-page-heading :id="idName">利用明細</a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      id="-companyId"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section variant="fullpage">
      <m-action-card class="t-price-history-list__card" title="ご利用料金一覧" icon="file">
        <div class="t-price-history-list__data-table">
          <m-data-table ref="dataTable" :empty-text="emptyText" :fit="true" :data="dataList" :is-loading="isLoading">
            <a-data-table-column prop="billing_date" label="<span>請求年月</span>" align="left">
              <template #default="scope">
                {{ getBillingDate(scope.row.billing_date) }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="amount" label="<span>通話時間<br/>（着信）</span>" align="left">
              <template #default="scope">
                {{ scope.row.incoming_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_method" label="<span>通話時間<br/>（発信 / 携帯）</span>" align="left">
              <template #default="scope">
                {{ scope.row.mobile_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>通話時間<br/>（発信 / 固定）</span>" align="left">
              <template #default="scope">
                {{ scope.row.fixed_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>通話時間<br/>（内線）</span>" align="left">
              <template #default="scope">
                {{ scope.row.extension_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_id" label="<span>利用ID数</span>" align="left">
              <template #default="scope">
                {{ scope.row.id }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>利用番号数</span>" align="left">
              <template #default="scope">
                {{ scope.row.usage_number }}
              </template>
            </a-data-table-column>
          </m-data-table>
        </div>
        <div v-if="showPagination && !isLoading" class="t-price-history-list__pagination">
          <a-pagination :length="pageCount" :current-index="page" @page:selected="handlePageSelect" />
        </div>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="priceHistoryList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APagination from '@/components/atoms/pagination';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';
import { utils } from '@/common/utils.js';

export default {
  name: 't-price-history-list',
  components: {
    APagination,
    APageHeading,
    MSection,
    MActionCard,
    MDataTable,
    ADataTableColumn,
  },
  mixins: [customRequest, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 0,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    handlePageSelect: {
      type: Function,
      default: () => {},
    },
    handleItemSelect: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      dataList: [],
      selectedCompanyID: '',
      companyIDList: [],
      authInfo: this.$store.state.user.authInfo,
      POINT,
      emptyText: messageContent.alertMessageEmptyText(),
      idName: 'h1-pricehistorylist',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-price-history-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (
        (this.companyID === POINT && newValue !== POINT && this.authInfo === 'operator') ||
        (this.companyID !== POINT && newValue !== this.companyID)
      ) {
        // 権限がない(003300のオペレータ, または003300以外の企業)の場合、他の企業IDは閲覧不可
        this.$router.push({ path: '/permission-denied' });
      } else {
        if (newValue && newValue !== oldValue) {
          if (
            this.companyID === POINT &&
            this.selectedCompanyID !== this.$route.query.companyID &&
            newValue &&
            oldValue
          ) {
            // リストから選択した場合は旧＆新のIDがある
            await this.$router.push({ query: { companyID: this.selectedCompanyID } });
          }
          this.fetchUsageListHandler();
          // トライアル企業の場合(切替含む)は、アラートメッセージを表示する
          const tmpCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
          if (utils.chkTrialCompanyID(tmpCompanyID)) {
            this.showInfoModal(messageContent.trialCompanyHideFrequency);
          }
        }
        if (!newValue) {
          this.selectedCompanyID = oldValue;
        }
      }
    },
  },
  created() {
    if (this.companyID === POINT && PERMISSIONS_FRONTEND['otherPriceListReading'][this.authInfo]) {
      this.selectedCompanyID = POINT;
      this.fetchCompanyIDListHandler();
    }

    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else if (
      (this.companyID === POINT && this.authInfo === 'operator') ||
      (this.companyID !== POINT && this.authInfo !== 'operator')
    ) {
      // 料金状況画面が確認可能でかつ他企業が見れない権限の場合はここで一覧を取得
      // 003300のオペレータ、その他IDのオペレータ以外の権限
      this.fetchUsageListHandler();
      // トライアル企業の場合(切替含む)は、アラートメッセージを表示する
      const tmpCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
      if (utils.chkTrialCompanyID(tmpCompanyID)) {
        this.showInfoModal(messageContent.trialCompanyHideFrequency);
      }
    }
  },
  mounted() {
    console.info('mouted');
    if (
      (this.companyID === POINT && this.authInfo === 'soOperator') ||
      (this.companyID !== POINT && this.authInfo === 'operator')
    ) {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の検索'));
        });
    },
    getBillingDate(date) {
      return date.substring(0, 7);
    },
    fetchUsageListHandler: async function () {
      await this.postRequest('/usage/getusage', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            throw new Error('/usage/getusage response was not ok.');
          }
          // リスト初期化
          this.dataList.splice(0, this.dataList.length);
          e.result.forEach(row => {
            const list = {
              billing_date: row.date,
              incoming_duration: row.type2,
              mobile_duration: row.type0,
              fixed_duration: row.type1,
              extension_duration: row.type5,
              id: row.type6,
              usage_number: row.type7,
            };
            this.dataList.push(list);
          });
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
  },
};
</script>
